<template>
  <div>
    <b-card
      no-body
      class="border-0"
      style="width: 320px; height: 100%; border-radius: 55px 55px 90px 90px;"
      :style="backgroundStyle"
    >
      <img
        class="img-responsive img-fluid position-absolute top-0"
        src="@/assets/img/mockups/smartphone-mockup.png"
        width="400px"
        style="min-height: 700px; max-height: 700px"
      />
      <b-card-header
        :style="`${headerStyle}`"
        class="p-4 mt-2 smartphone-border-radius"
      >
        <b-row class="pa-2 px-3">
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-between mt-2"
          >
            <b-button
              class="border-0"
              :variant="iconColor"
              @click="opened = true"
            >
              <i class="fas fa-bars" :style="`${iconStyle}`"></i>
            </b-button>
            <b-img
              v-if="companyLogo"
              :src="`${getImagesAddressApp}${companyLogo}`"
              fluid
              width="70%"
              class="mt-4 mr-3"
            ></b-img>
            <i class="fas fa-shopping-cart" :style="`${iconStyle}`"></i>
          </b-col>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-between mt-3 mb-3"
          >
            <b-input placeholder="Buscar produto"></b-input>
            <i class="fas fa-search ml-2 mr-2" :style="`${iconStyle}`"></i>
            <i class="fas fa-camera ml-2" :style="`${iconStyle}`"></i>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-text class="pr-3 pl-3">
        <h4 class="text-center mt-4 mb-5 c-black">
          <i class="fas fa-user mr-1" :style="`${iconStyle}`"></i>
          {{ titleDinamic }}
        </h4>
        <b-col v-if="isClient">
          <b-row>
            <b-col cols="10">
              <i class="fas fa-user mr-2" :style="`${iconStyle}`"></i>
              Cliente
            </b-col>
            <b-col cols="2">
              <input type="radio"></input>
            </b-col>
          </b-row>
          <hr class="lineTop">
        </b-col>

        <b-col v-if="isProfessional" class="mt-2">
          <b-row>
            <b-col cols="10">
              <i class="fas fa-tools fs-16 mr-2" :style="`${iconStyle}`"></i>
              Profissional
            </b-col>
            <b-col cols="2">
              <input type="radio"></input>
            </b-col>
          </b-row>
          <hr class="lineTop">
        </b-col>

        <b-col v-if="isShopkeeper" class="mt-2">
          <b-row>
            <b-col cols="10">
              <i class="fas fa-building mr-2" :style="`${iconStyle}`"></i>
              Empresa
            </b-col>
            <b-col cols="2">
              <input type="radio"></input>
            </b-col>
          </b-row>
          <hr class="lineTop">
        </b-col>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'FakeAppNewUser',
  props: {
    headerMenuColor: {
      type: String,
      required: false,
      default: 'white',
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'black',
    },
    fontColor: {
      type: String,
      required: false,
      default: 'black',
    },
    titleDinamic: {
      type: String,
      required: false,
    },
    isClient: {
      type: Boolean,
      required: true,
      default: true
    },
    isProfessional: {
      type: Boolean,
      required: true,
      default: true
    },
    isShopkeeper: {
      type: Boolean,
      required: true,
      default: true
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
    iconStyle() {
      return `color: ${this.iconColor};`;
    },
    fontStyle() {
      return `color: ${this.fontColor};`;
    },
    backgroundStyle() {
      return `background-color: ${this.backgroundColor};`;
    },
    headerStyle() {
      return `background-color: ${this.headerMenuColor};`;
    },
  },
  watch: {
    opened(newValue) {
      if (!newValue) return;

      setTimeout(() => {
        this.addMenuBackgroundColor();
      }, 10);
    },
    backgroundColor() {
      this.addAppBackgroundColor();
      this.addMenuBackgroundColor();
    },
  },
  data() {
    return {
      opened: false,
      companyLogo: '',
      image: '',
    };
  },
  mounted() {
    this.$root.$on('valid-logo-about-app', () => {
      this.getCompanyLogo(); 
    });
    this.getCompanyLogo();
    this.addMenuBackgroundColor();
    this.addAppBackgroundColor();
    this.getCompanyAbout();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getAboutCompany', 
      'listBanner', 
      'getMenusApp',
      'getCustomization'
    ]),
    addMenuBackgroundColor() {
      const menuBackground =
        document.getElementsByClassName('b-sidebar-body')[0];

      if (!menuBackground) return;

      menuBackground.style.backgroundColor = this.backgroundColor;
    },
    addAppBackgroundColor() {
      const appBackground = document.getElementsByClassName('card')[0];

      if (!appBackground) return;

      appBackground.style.backgroundColor = this.backgroundColor;
    },
    async getCompanyLogo() {
      this.getAboutCompany(this.dadosUsuario.id)
        .then((response) => {
          const { logo } = response.data.data || {};
          this.companyLogo = logo || '';
        })
        .catch(() => {})
        .finally(() => {});
    },
    getCompanyAbout() {
      this.getAboutCompany(this.dadosUsuario.id)
        .then((response) => {
          this.image = response.data.data.image;
        })
        .catch(() => {})
        .finally(() => {});
    },
  }
}
</script>

<style scoped>
body {
  padding: 1rem;
}

>>> .bg-light {
  background-color: transparent !important;
}

.fake-app-menu {
  width: 70%;
  margin-left: 19px;
  margin-top: 50px;
}

.cap-content {
    background: white;
    width: 550px;
    height: 120px;
    position: relative;
    bottom: 20%;
    z-index: 9999;
}

>>> .fake-app-menu.b-sidebar-outer {
  position: absolute !important;
  height: 90.1% !important;
}

>>> .fake-app-menu .b-sidebar {
  position: absolute !important;
  height: 100% !important;
}

>>> .b-sidebar > .b-sidebar-body {
  overflow: hidden;
  border-radius: 8px 0 0px 30px;
}

.smartphone-border-radius {
  border-radius: 75px 75px 0 0;
}

.lineTop{
  margin-top: 0px;
}
</style>